__turbopack_context__.v({
  "burn": "HoloFx-module-scss-module__iDS8oG__burn",
  "holoFx": "HoloFx-module-scss-module__iDS8oG__holoFx",
  "light": "HoloFx-module-scss-module__iDS8oG__light",
  "overlay": "HoloFx-module-scss-module__iDS8oG__overlay",
  "texture": "HoloFx-module-scss-module__iDS8oG__texture",
});
